export default __webpack_public_path__ + "static/media/ddsu5168_4p.7099bb71.png";